import { MdsBanner, MdsButton, MdsTextInput } from "@mds/react";
import "./choose-target-stylesheet.scss";
import "./enter-otp-stylesheet.scss";

const EnterOTP = () => {
  return (
    <div id="enter-otp">
      <div className="back-button-mobile-wrapper">
        <MdsButton
          text="Back"
          iconAccessibleDescription=""
          iconType="ico_chevron_left"
          iconPosition="leading"
          id="mb-enter-otp-back-button"
          variant="tertiary"
        />
      </div>

      <h2 id="sign-in-greeting" className="title-xlarge">
        Sign in to the dashboard
      </h2>

      <p id="where-should-we-send" className="body-large">
        Enter your access code:
      </p>

      <MdsBanner
        id="error-message-hidden"
        bannerTitle="Error"
        showCloseButton={false}
        bannerMessage="Initial error message"
        variant="critical"
        accessibleTextIcon="Informational Icon"
        background="themed"
      />

      <form id="enter-otp-form">
        <MdsTextInput id="otp" label="Access code" variant="box" />
        <MdsButton
          variant="tertiary"
          id="otp-resend-button"
          text="Resend Code"
        />

        <div className="send-code-btn-wrapper">
          <MdsButton
            id="otp-submit-button"
            text="Submit"
            variant="primary"
            widthType="layout"
          />
        </div>
      </form>
    </div>
  );
};

export default EnterOTP;
